import { render } from "./ContrattoRead.vue?vue&type=template&id=33ba0f76"
import script from "./ContrattoRead.vue?vue&type=script&lang=js"
export * from "./ContrattoRead.vue?vue&type=script&lang=js"

import "./ContrattoRead.vue?vue&type=style&index=0&id=33ba0f76&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__